// @flow
import {
  PIN_NAV,
  RECEIVE_VERSIONS,
  TOGGLE_PRIVATE,
  UNPIN_NAV
} from '../reducers/app';

import createAction from './utils/createAction';

export const pinNav = createAction(PIN_NAV);
export const receiveVersions = createAction(RECEIVE_VERSIONS);
export const togglePrivate = createAction(TOGGLE_PRIVATE);
export const unpinNav = createAction(UNPIN_NAV);



// WEBPACK FOOTER //
// ./src/actions/app.js